import { render, staticRenderFns } from "./NewbieTaskReminder.vue?vue&type=template&id=10186821&scoped=true&"
import script from "./NewbieTaskReminder.vue?vue&type=script&lang=js&"
export * from "./NewbieTaskReminder.vue?vue&type=script&lang=js&"
import style0 from "./NewbieTaskReminder.vue?vue&type=style&index=0&id=10186821&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10186821",
  null
  
)

export default component.exports